import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Row, Col, Container, Button, Card, CardImg, CardText, CardBody, CardTitle, CardSubtitle, Alert, Progress, Media } from 'reactstrap';
import firebase from './firebase';
import './App.css';

class Game extends Component {

  videoRef = React.createRef();
  canvasRef = React.createRef();

  classes = ["person", "bicycle", "car", "motorcycle", "bench", "cat", "dog", "umbrella", "handbag", "tie", "suitcase", "skateboard", "bottle", "wine", "glass", "cup", "fork",, "knife", "spoon", "bowl", "banana", "apple", "chair", "couch", "potted", "plant", "bed", "dining", "table", "toilet", "tv", "laptop", "keyboard", "cell", "phone", "oven", "toaster", "sink", "refrigerator", "book", "clock", "vase", "scissors", "teddy", "bear", "hair", "drier", "toothbrush"];

  // we are gonna use inline style
  styles = {
    position: 'fixed',
    top: 150,
    left: 150,
  };


  detectFromVideoFrame = (model, video) => {
    model.detect(video).then( (predictions) => {
      
      // console.log(video.width, video.height);
      this.showDetections(predictions, video);

      requestAnimationFrame(() => {
        this.detectFromVideoFrame(model, video);
      });
    }, (error) => {
      // console.log()
      this.setAlert("Couldn't start the webcam")
      // console.error(error)
    });
  };

  showDetections = (predictions, video) => {

    predictions.forEach(prediction => {
      let found = prediction.class;
      if(this.classes.includes(found) && (prediction.score > 0.90) ) {
        // this.setState({alertText: found + ", Height: " + video.height, });

        // this.setState({alertText: found, alertVisible: true});
        // this.timedAlert();

        if(!this.myFoundObjects.includes(found)) {

          // console.log(this.myFoundObjects.length)

          // console.log(prediction.score)
          this.myFoundObjects.push(found)
          let ref = firebase.database().ref('users').child(firebase.auth().currentUser.uid);
          ref.push({found: found});

          let refGroup = firebase.database().ref('findings').child('group');
          refGroup.push({email: firebase.auth().currentUser.email, found: found});
          // this.setAlert(firebase.auth().currentUser.email + " found " + found)
          // this.setState({alertText: found, alertVisible: true});
          // this.timedAlert();

          // console.log(this.myFoundObjects.length)
          this.setState({progress: Math.round(100*this.myFoundObjects.length/48) })
          this.setState({progressAbsolut: this.myFoundObjects.length })
        }

        /*let ref = firebase.database().ref('users').child(firebase.auth().currentUser.uid);
        ref.push({found: found});*/

        /*let canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        
        let context = canvas.getContext('2d');
        context.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
        this.setState({imgSrc: canvas.toDataURL()});*/


        /*this.canvasRef.width = video.videoWidth;
        this.canvasRef.height = video.videoHeight;*/
        /*this.canvasRef.getContext('2d').drawImage(video, 0, 0, video.videoWidth, video.videoHeight);  
        this.canvasRef.toBlob((blob) => {
          let img = new Image();
          this.setState({imgSrc: window.URL.createObjectUrl(blob)});
        });*/
      }
    });
  };

  setAlert = (txt) => {

    // console.log("in set alert", this.alertList.length)

    if(this.alertList.length > 2) {
      this.alertList = []
    }

    this.alertList.push(txt)

    let txtToSet = "";
    for(let counter = 0; counter < this.alertList.length; counter++) {
      if(counter < (this.alertList.length-1)) {
        txtToSet += this.alertList[counter] + " | "
      } else {
        txtToSet += this.alertList[counter]
      }
    }

    // console.log(txtToSet)

    this.setState({alertText: txtToSet, alertVisible: true})
  }

  componentDidMount() {

    // firebase.auth().currentUser.uid
    // firebase.auth().currentUser.email 
    // let ref = firebase.database().ref('users').child(firebase.auth().currentUser.uid);
    // ref.push({found: "found"})

    if (navigator.mediaDevices.getUserMedia || navigator.mediaDevices.webkitGetUserMedia) {
      // define a Promise that'll be used to load the webcam and read its frames
      
      // https://developer.mozilla.org/en-US/docs/Web/API/MediaTrackConstraints/facingMode
      // video: {facingMode: "user", width: 400, height: 400, frameRate: { ideal: 10, max: 10 }},
      // environment

      // this.setState({alertText: "Bitte Kamera zulassen und kurz warten...", alertVisible: true});
      this.setAlert("Bitte Kamera zulassen und kurz warten...")
      // this.timedAlert();

      const webcamPromise = navigator.mediaDevices
        .getUserMedia({
          video: {facingMode: "environment", width: 400, height: 600},
          audio: false,
        })
        .then(stream => {
          // pass the current frame to the window.stream
          window.stream = stream;
          // pass the stream to the videoRef
          this.videoRef.current.srcObject = stream;

          return new Promise(resolve => {
            this.videoRef.current.onloadedmetadata = () => {
              resolve();
            };
          });
        }, (error) => {
          // console.log("Couldn't start the webcam")
          this.setAlert("Couldn't start the webcam")
          // console.error(error)
        });

      // define a Promise that'll be used to load the model
      const loadlModelPromise = this.cocoSsd.load();
      
      // resolve all the Promises
      Promise.all([loadlModelPromise, webcamPromise])
        .then(values => {
          
          this.setAlert("Die Suche kann beginnen...")
          // this.setState({alertText: "", alertVisible: false});
          // this.timedAlert();
          // console.log("modeL and webcam loaded...");
          this.detectFromVideoFrame(values[0], this.videoRef.current);
        })
        .catch(error => {
          this.setAlert("Leider trat ein Fehler auf")
          // console.error(error);
        });
    }
  }

  // this.timedAlert (text) => setTimeout((text) => this.setState({alertVisible: false}), 3000);
  timedAlert = () => {setTimeout(() => this.setState({alertVisible: false}), 3000)};

  constructor(args) {
    super(args);

    this.cocoSsd = require('@tensorflow-models/coco-ssd');
    this.alertList = []

    this.myFoundObjects = []
    let ref = firebase.database().ref('users/' + firebase.auth().currentUser.uid);

    this.state = {
      alertVisible: false,
      alertText: "",
      spinnerVisible: false,
      imgSrc: "",
      progress: 0,
      progressAbsolut: 0
    };

    ref.once("value")
      .then((snapshot) => {
        snapshot.forEach((childSnapshot) => {
          // key will be "ada" the first time and "alan" the second time
          var key = childSnapshot.key;
          // childData will be the actual contents of the child
          var childData = childSnapshot.val();

          this.myFoundObjects.push(childData.found)

          // console.log(this.myFoundObjects)

          this.setState({progress: Math.round(100*this.myFoundObjects.length/48) })
          this.setState({progressAbsolut: this.myFoundObjects.length })
          

          // console.log(this.state.progress)
      });
    });




    
    var refGroup = firebase.database().ref('findings/group').orderByKey();
    refGroup.on("child_added", (snapshot) => {

        if(snapshot && snapshot.val()) {
          // console.log("in if...")
          // console.log(snapshot.val())
          this.setAlert(snapshot.val().email + " hat noch ein Osterei gefunden");
        }

        snapshot.forEach((childSnapshot) => {
          var childData = childSnapshot.val();

          // this.myFoundObjects.push(childData.found)
      });
    });


  }

  onDismiss = () => this.setState({alertVisible: false});

  letsGo = () => {
    const {history} = this.props;
    history.push('/game');
  }
  
  // toggle={onDismiss}
  render() {
    return (
        <Container id="game">

        <Alert color="info" isOpen={this.state.alertVisible} toggle={this.onDismiss}>
          {this.state.alertText}
        </Alert>

        <div className="text-center"><img src={require('./img/EasterEgg64.png')} /></div>

        <div className="text-center">Meine gefundenen Ostereier</div>
        <div className="text-center">{this.state.progressAbsolut}</div>
        <Progress value={this.state.progress} />
        
        <Row>

        <video
          autoPlay
          muted
          ref={this.videoRef}
          width="50%"
          height="50%"
          autoPlay
          playsInline
        />
        <canvas ref={this.canvasRef} width="50%" height="50%" />
      </Row>

        <Row>
          <Col>
      
        
        </Col>
        </Row>
        
      </Container>
    );
  }
  
}

export default withRouter(Game);


// WEBPACK FOOTER //
// ./src/Game.js